import fetchPortalJson from '../../js/PortalFetchJson'

const state = () => ({
  retrievedLeadRequests: [],
  currentLeadRequests: [],
  pendingLeadRequests: [],
  pendingBulkSubmits: [],
  submittingBulk: false,
  leadRequestsFull: false,
  waitForOfferSubmit: false
})

const getters = {
  getRequests (state) {
    var requests = [...state.currentLeadRequests, ...state.retrievedLeadRequests]
    return requests
  }
}

const actions = {
  async loadPreviousLeadRequests ({ commit }, { consumerId, maxSubmits }) {
    var leadRequestsResult = await fetchPortalJson(`lead_requests?consumer_id=${consumerId}`)
    var foundRequests = leadRequestsResult.lead_requests.map((request) => {
      var offer = leadRequestsResult.offers.find((offerObject) => offerObject.id === request.offer_id)
      var offerName = offer.name
      var campusName = request.campus[0].name
      var programName = request.program[0].name
      return {
        offer: {
          id: offer.id,
          name: offerName,
          isWt: offer.is_warm_transfer,
          logoURL: offer.logo_url,
          shortDescription: offer.short_description,
          offerExternalNameId: offer.offer_external_name_id,
          externalNameId: Array.isArray(offer.offer_external_name_ids) ? offer.offer_external_name_ids : [offer.offer_external_name_ids],
          exclusive: offer.exclusive
        },
        offerId: offer.id,
        offerExternalNameId: request.offer_external_name_id,
        externalNameId: Array.isArray(request.offer_external_name_ids) ? request.offer_external_name_ids : [request.offer_external_name_ids],
        externalNameInclusiveOfferId: request.offer_external_name_inclusive_offer_id,
        campusName: campusName,
        programName: programName,
        status: request.status,
        errors: request.response_to_publisher.reason
      }
    })
    if (foundRequests.some((request) => (request.offer.isWt || request.offer.exclusive) && request.status === 'Accepted') || foundRequests.filter((request) => request.status === 'Accepted').length >= maxSubmits) {
      commit('setLeadRequestsFull')
    }
    commit('setRetrievedRequests', foundRequests)
  }
}

const mutations = {
  setRetrievedRequests (state, requests) {
    state.retrievedLeadRequests = requests
  },
  addLeadRequest (state, newRequest) {
    state.currentLeadRequests.push(newRequest)
  },
  setLeadRequestsFull (state) {
    state.leadRequestsFull = true
  },
  addPendingLeadRequest (state, pendingRequest) {
    state.pendingLeadRequests.push(pendingRequest)
  },
  removePendingLeadRequest (state, pendingRequest) {
    var index = state.pendingLeadRequests.findIndex((plr) => plr.id === pendingRequest.id)
    state.pendingLeadRequests.splice(index, 1)
  },
  addPendingBulkSubmit (state, submitObject) {
    state.pendingBulkSubmits.push(submitObject)
  },
  removePendingBulkSubmit (state, submitObject) {
    var index = state.pendingBulkSubmits.findIndex((pbs) => pbs.offer.id === submitObject.offer.id && pbs.offer.displayedOfferId === submitObject.offer.displayedOfferId)
    state.pendingBulkSubmits.splice(index, 1)
  },
  removeAllPendingBulkSubmit (state) {
    state.pendingBulkSubmits = []
  },
  removeAllPendingLeadRequest (state) {
    state.pendingLeadRequests = []
  },
  toggleSubmittingBulk (state) {
    state.submittingBulk = !state.submittingBulk
  },
  toggleWaitForOfferSubmit (state) {
    state.waitForOfferSubmit = !state.waitForOfferSubmit
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
